import React, { useState } from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaFilterChips, { IKuikaFilterChipOption } from "../../../../ui-kit/kuika-filter-chips/kuika-filter-chips";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

interface IDemoJob {
  name: string;
  status: string;
}

const STATUSES: IKuikaFilterChipOption[] = [
  { label: "Active", value: "active" },
  { label: "Paused", value: "paused" },
  { label: "Failed", value: "failed" }
];

const INITIAL_JOBS: IDemoJob[] = [
  { name: "Nightly export", status: "active" },
  { name: "Invoice sync", status: "active" },
  { name: "Cache warm-up", status: "paused" },
  { name: "Mail digest", status: "failed" }
];

const countOf = (jobs: IDemoJob[], status: string): number =>
  jobs.filter((job: IDemoJob): boolean => job.status === status).length;

export const FilterChipsStory: React.FC = (): JSX.Element => {
  const [selected, setSelected] = useState<string[]>([]);
  const [jobs, setJobs] = useState<IDemoJob[]>(INITIAL_JOBS);

  const options: IKuikaFilterChipOption[] = STATUSES.map((option: IKuikaFilterChipOption): IKuikaFilterChipOption => ({
    ...option,
    count: countOf(jobs, option.value)
  }));

  const addJob = (status: string): void => {
    setJobs([...jobs, { name: `Job ${jobs.length + 1}`, status }]);
  };

  return (
    <ShowcaseFrame
      title="Filter chips"
      componentName="KuikaFilterChips"
      sourcePath="ui-kit/kuika-filter-chips"
      description="A row of toggleable 28px filter pills with OR selection. Turning a chip on opens a check slot and draws the check; counts roll when they change."
    >
      <SpecRow label="Toggle" caption="select → the ✓ slot opens and the check draws · Tab to focus, Space to toggle">
        <KuikaFilterChips
          options={options}
          value={selected}
          onChange={setSelected}
          allCount={jobs.length}
          groupLabel="Status"
        />
      </SpecRow>
      <SpecRow label="Live counts" caption="the changed digits roll">
        <KuikaButton type="secondary" size="sm" onClick={(): void => addJob("active")}>
          Add active job
        </KuikaButton>
        <KuikaButton type="secondary" size="sm" onClick={(): void => addJob("failed")}>
          Add failed job
        </KuikaButton>
        <KuikaButton type="tertiary" size="sm" onClick={(): void => setJobs(INITIAL_JOBS)}>
          Reset
        </KuikaButton>
      </SpecRow>
      <SpecRow label="Without All" caption="allLabel={null}">
        <KuikaFilterChips
          options={options}
          value={selected}
          onChange={setSelected}
          allLabel={null}
          groupLabel="Status"
        />
      </SpecRow>
    </ShowcaseFrame>
  );
};
